import { defineAsyncComponent } from 'vue';

export const revenueReportForecastFrontends = {
	RevenueReportForecast: defineAsyncComponent(
		() => import('./components/RevenueReportForecast')
	),
};
